<template>
    <th class="sortable-th" :class="{ 'sortable-th--active': active }" @click="$emit('sort', sortKey)">
        <slot>{{ label }}</slot>
        <v-icon class="sortable-th-arrow" size="14">{{ arrow }}</v-icon>
    </th>
</template>

<script>
export default {
    name: 'SortableTh',
    props: {
        label: {
            type: String,
            default: '',
        },
        sortKey: {
            type: String,
            required: true,
        },
        sortBy: {
            type: String,
            default: null,
        },
        desc: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        active(vm = this) {
            return vm.sortBy === vm.sortKey
        },
        arrow(vm = this) {
            return vm.active && !vm.desc ? 'mdi-menu-up' : 'mdi-menu-down'
        },
    },
}
</script>

<style scoped>
.sortable-th {
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
}

.sortable-th:hover {
    color: var(--v-txtPrimary-base);
}

.sortable-th-arrow {
    margin-left: 2px;
    opacity: 0.35;
    color: inherit !important;
}

.sortable-th--active {
    color: var(--v-txtPrimary-base);
}

.sortable-th--active .sortable-th-arrow {
    opacity: 1;
    color: var(--v-accent-base) !important;
}
</style>
